import React, { useState } from 'react';
import Select from 'react-select';
import { Field } from 'formik';

import Label from '@/components/forms/label';
import Description from '@/components/forms/description';

import DropdownIndicator from './DropdownIndicator';
import { ReactSelectClassNames } from './Shared';
import styles from './Select.module.css';

function MultiSelect({
    classNamePrefix = undefined,
    labelClassName = 'text-cleanSlate text-[14px]',
    defaultOptions = [],
    disabled = false,
    description = '',
    error = false,
    errorText = '',
    label = '',
    name,
    onChange = (_opt) => { },
    options,
    placeholder = '',
    maxLimit = 5,
    isClearable = false,
}) {
    const [selectRef, setSelectRef] = useState(null);

    const getValue = (field) => {
        if (!(options.length > 0) || !field.value) {
            return [];
        }

        if (options[0].options && options[0].options.length > 0) {
            const selectedOptions = [];
            options.forEach((group) => {
                group.options.forEach((option) => {
                    if (field.value.indexOf(option.value) >= 0) {
                        selectedOptions.push(option);
                    }
                });
            });
            return selectedOptions;
        }
        return options.filter((option) => field.value.indexOf(option.value) >= 0);
    };

    const handleOnChange = (selectedOptions, form) => {
        if (!selectedOptions) {
            form.setFieldValue(name, []);
            onChange(selectedOptions);
            return;
        }

        form.setFieldValue(
            name,
            selectedOptions.map((option) => {
                if (option.value) {
                    return option.value;
                } if (option.options) {
                    return option.options;
                }
                return option;
            }),
        );

        onChange(selectedOptions);
    };

    return (
        <div>
            {label && (
                <Label
                    className={labelClassName}
                    htmlFor={name}
                    label={label}
                    onClick={() => { selectRef?.focus(); }}
                />
            )}
            <Field
                name={name}
            >
                {
                    ({
                        field,
                        form,
                    }) => (
                        <Select
                            classNamePrefix={classNamePrefix}
                            name={name}
                            ref={(ref) => { setSelectRef(ref); }}
                            value={getValue(field)}
                            menuPortalTarget={document.body}
                            isMulti
                            defaultValue={defaultOptions}
                            options={options}
                            classNames={ReactSelectClassNames(error)}
                            components={{ DropdownIndicator }}
                            isDisabled={disabled}
                            onChange={(selectedOptions) => handleOnChange(selectedOptions, form)}
                            placeholder={placeholder}
                            menuPlacement="auto"
                            isClearable={isClearable}
                            isOptionDisabled={() => getValue(field).length >= maxLimit}
                        />
                    )
                }
            </Field>
            <Description description={description} />
            {error && errorText.length > 0 && (
                <div className={styles.errorText}>
                    {errorText}
                </div>
            )}
        </div>
    );
}

export default MultiSelect;
